<template>
  <div class="z-main">
    <header class="z-header">
      <div>
        <router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link>
      </div>
      <div>一键托管</div>
      <div>
        <!-- <router-link to="/index/newAccount">新增</router-link> -->
      </div>
    </header>
    <div class="z-body z-body-bottom">
      <div v-for="(item,index) in data" class="z-keyOrder-item">

        <div class="z-subAccount-user">
          <img :src="item.avatar" class="z-user-avatar">
          <div class="z-subAccount-info">
            <div v-text="item.name"></div>
            <div v-text="'交易号：'+(item.trade_account ? item.trade_account : '待入金')"></div>
          </div>
        </div>
        <!-- <div class="z-subAccount-state" v-if="selectIn.includes(item.uid)"> -->
        <div class="z-subAccount-state d-space-row">
          <div v-if="item.is_entrust == 1" class="margin-left-right pad-left-right" style="border-right: 1px solid #ddd;" @click="onConfirm(item.uid)"><img
              src="../../assets/index/sub-account/delete.png" alt="" class="z-icon"></div>
          <div @click="selectUid(item.uid)">
            <img src="../../assets/index/sub-account/yes.png" class="z-icon" v-if="selectIn.includes(item.uid)">
            <img src="../../assets/index/sub-account/no.png" class="z-icon" v-else>
          </div>
        </div>
      </div>
    </div>
    <div class="z-gather-box">
      <!-- <router-link :to="{path:'/index/keyOrderDown',query:{uids:selectIn.join(',')}}"> -->
      <div class="z-btn-long z-gather-btn" @click="onEscrow">一键托管</div>
      <!-- </router-link> -->
    </div>

    <v-dialog v-model="isShow" max-width="290">
      <v-card light>
        <v-card-title>提示</v-card-title>
        <v-card-text>是否取消托管？</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black darken-1" flat="flat" @click="isShow=false">取消</v-btn>
          <v-btn color="green darken-1" flat="flat" @click="onDelete">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'keyOrder',
    data() {
      return {
        data: [],
        selectIn: [],

        uid:'',
        isShow:false,

      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        this.get('api/users/childs', {}).then((rs) => {
          if (rs.code == 0) {
            this.data = rs.data
          }
        })
      },
      onConfirm(uid){
        this.isShow = true
        this.uid = uid
      },
      onDelete(){
        let params = {
          act: 'del',
          id:this.uid
        }
        this.post('api/users/entrust', params).then((rs) => {
          if (rs.code == 0) {
            this.init()
          }
          this.$store.commit('layer', rs.msg)
          this.isShow = false
        })
      },
      selectUid(uid) {
        let idx = this.selectIn.indexOf(uid)
        if (idx === -1) {
          this.selectIn.push(uid)
        } else {
          this.selectIn.splice(idx, 1)
        }
      },
      onEscrow() {
        let params = {
          act: 'add',
          ids: this.selectIn.join(','),
        }
        if(this.selectIn.length == 0){
          this.$store.commit('layer', '请至少选择一项')
          return
        }
        this.get('api/users/entrust', params).then((rs) => {
          if (rs.code == 0) {
            this.init()
          }
          this.$store.commit('layer', rs.msg)
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .z-gather-box {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background: #fff;
    /* border-top: 2px solid #1E1F22; */
    border-top: 1px solid #515151;
  }

  .z-gather-btn {
    border-radius: 0px;
  }

  /*新*/
  .z-keyOrder-item {
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid #515151;
  }

  .z-subAccount-user {
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .z-subAccount-info div:nth-child(2) {
    font-size: 10px;
    color: #9B9A9C;
  }

  .z-icon {
    width: 16px;
    height: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/keyOrderEscrow.vue